import { UseCase } from '../../base';
import { AdditionalDataKey } from '../../domain/models';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdditionalDataKeysRepository } from '../../repositories';

@Injectable({providedIn: 'root'})
export class GetAdditionalDataKeyUseCase
  implements UseCase<string, AdditionalDataKey>
{
  constructor(
    private additionalDataKeyRepository: AdditionalDataKeysRepository
  ) {}

  execute(params: string): Observable<AdditionalDataKey> {
    return this.additionalDataKeyRepository.getAdditionalDataKey(params);
  }
}
